import React from 'react';
import clsx from 'clsx';
import styles from './SliderField.module.scss';
import Field from '../../Field/components/Field';
import Stack from '../../Stack/components/Stack';
import FormRow from '../../FormRow/components/FormRow';
import RangeInput from '../../RangeInput/components/RangeInput';
import RangeValue from '../../RangeValue/components/RangeValue';
import RangeTicks from '../../RangeTicks/components/RangeTicks';

const SliderField = ({
  label,
  value,
  unit,
  min,
  max,
  ticks,
  helpText,
  error,
  onChange,
  className,
  ...inputProps
}) => {
  return (
    <Field
      label={label}
      helpText={helpText}
      error={error}
      className={className}
    >
      <FormRow align="center" className={styles.row}>
        <Stack gap="xs" className={styles.sliderContainer}>
          <RangeInput
            min={min}
            max={max}
            value={value}
            onChange={onChange}
            {...inputProps}
          />
          {ticks && ticks.length > 0 && (
            <RangeTicks min={min} max={max} ticks={ticks} />
          )}
        </Stack>
        <RangeValue value={value} unit={unit} />
      </FormRow>
    </Field>
  );
};

export default SliderField;
